import { defineComponent as o, computed as a, createBlock as l, openBlock as m, unref as s, normalizeClass as i } from "vue";
import { RevAvatar as u } from "@ds/components/Avatar";
import c from "../../../icons/generated/IconBackMarketAvatar.vue2.js";
import f from "../../../icons/generated/IconShop.vue2.js";
const k = /* @__PURE__ */ o({
  __name: "MessageAvatar",
  props: {
    variant: {},
    label: {}
  },
  setup(r) {
    const e = r, t = a(() => e.variant === "customer" ? "mood-purple" : e.variant === "seller" ? "mood-emerald" : "mood-blush"), n = a(() => {
      if (e.variant === "backmarket") return c;
      if (e.variant === "seller") return f;
    });
    return (p, v) => (m(), l(s(u), {
      class: i(t.value),
      label: r.label,
      size: "medium",
      thumbnail: n.value
    }, null, 8, ["class", "label", "thumbnail"]));
  }
});
export {
  k as default
};
